import CoreBase from '../../../services/engines/CoreBase';
import workspaceBeSync from './WorkspaceBeSync';
import { WS_STORE_KEY } from './workspaceConst';

/**
 * Persists workspace snapshots. Writes go to localStorage AND the BE (WorkspaceBeSync, Jerny
 * note format workspace_data). Reads still come from localStorage until a BE read endpoint
 * (notes by format/service) exists.
 * Snapshot shape: { rk, name, cards: [{ registryKey, meta, props, isPinned, displayState }], beRk? }
 */
class WorkspaceStore extends CoreBase {
    _name = 'WorkspaceStore';

    /**
     * @returns {object[]} all snapshots
     */
    getAll = () => {
        try {
            return JSON.parse(localStorage.getItem(WS_STORE_KEY) ?? '[]');
        } catch (error) {
            this.logError('getAll', error.message);
            return [];
        }
    };

    /**
     * @param {string} rk
     * @returns {object|null}
     */
    get = (rk) => this.getAll().find((s) => s.rk === rk) ?? null;

    /**
     * Adds or replaces a snapshot by rk, keeps an already known beRk.
     * @param {object} snapshot
     */
    save = (snapshot) => {
        const beRk = snapshot.beRk ?? this.get(snapshot.rk)?.beRk;
        const full = beRk ? { ...snapshot, beRk } : snapshot;
        this._writeLocal(full);
        workspaceBeSync.push(full, (newBeRk) => this._setBeRk(full.rk, newBeRk));
    };

    /**
     * @param {string} rk
     */
    remove = (rk) => {
        workspaceBeSync.remove(this.get(rk));
        this._writeAll(this.getAll().filter((s) => s.rk !== rk));
    };

    // ─── private ──────────────────────────────────────────

    _setBeRk = (rk, beRk) => {
        const snap = this.get(rk);
        if (snap) this._writeLocal({ ...snap, beRk });
    };

    _writeLocal = (snapshot) => {
        const items = this.getAll().filter((s) => s.rk !== snapshot.rk);
        items.push(snapshot);
        this._writeAll(items);
    };

    _writeAll = (items) => {
        try {
            localStorage.setItem(WS_STORE_KEY, JSON.stringify(items));
        } catch (error) {
            this.logError('_writeAll', error.message);
        }
    };
}

const workspaceStore = new WorkspaceStore();
export default workspaceStore;
